export default "/images/vendor/geoportal-extensions-openlayers/src/Common/CSS/waiting.gif?84926d9a24580720a06ec88d7108f41b";